import { render, staticRenderFns } from "./liaoyuanActivity.vue?vue&type=template&id=74362704&scoped=true&"
import script from "./liaoyuanActivity.vue?vue&type=script&lang=js&"
export * from "./liaoyuanActivity.vue?vue&type=script&lang=js&"
import style0 from "./liaoyuanActivity.vue?vue&type=style&index=0&id=74362704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74362704",
  null
  
)

export default component.exports